/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechStorageUsbOffIcon16Light } from './TechStorageUsbOffIcon16Light';
import { TechStorageUsbOffIcon16Regular } from './TechStorageUsbOffIcon16Regular';
import { TechStorageUsbOffIcon16Solid } from './TechStorageUsbOffIcon16Solid';
import { TechStorageUsbOffIcon20Light } from './TechStorageUsbOffIcon20Light';
import { TechStorageUsbOffIcon20Regular } from './TechStorageUsbOffIcon20Regular';
import { TechStorageUsbOffIcon20Solid } from './TechStorageUsbOffIcon20Solid';
import { TechStorageUsbOffIcon24Regular } from './TechStorageUsbOffIcon24Regular';
import { TechStorageUsbOffIcon24Solid } from './TechStorageUsbOffIcon24Solid';
import { TechStorageUsbOffIcon32Regular } from './TechStorageUsbOffIcon32Regular';
import { TechStorageUsbOffIcon64Regular } from './TechStorageUsbOffIcon64Regular';
var sizes = {
    16: {
        light: TechStorageUsbOffIcon16Light,
        regular: TechStorageUsbOffIcon16Regular,
        solid: TechStorageUsbOffIcon16Solid,
    },
    20: {
        light: TechStorageUsbOffIcon20Light,
        regular: TechStorageUsbOffIcon20Regular,
        solid: TechStorageUsbOffIcon20Solid,
    },
    24: {
        regular: TechStorageUsbOffIcon24Regular,
        solid: TechStorageUsbOffIcon24Solid,
    },
    32: {
        regular: TechStorageUsbOffIcon32Regular,
    },
    64: {
        regular: TechStorageUsbOffIcon64Regular,
    },
};
export var TechStorageUsbOffIcon = forwardRef('TechStorageUsbOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
